import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '@app/auth.service';

@Injectable({
  providedIn: 'root'
})
export class CreditNoteDataService {

  constructor(private http: HttpClient, private authService: AuthService) { }

  public getPdfData = (sfId: string, type: string) => {
    const promise = new Promise(async (resolve, reject) => {
      if (!type) {
        reject('No Type Selected');
      }

      const puppeteerData = localStorage.getItem('puppeteerData');

      if (puppeteerData !== null) {
        resolve(JSON.parse(puppeteerData));
      } else {
        if (type === 'creditnote') {
          resolve(await this.invoiceData(sfId, 'CREDIT_NOTE'));
        } else if (type === 'writeoff') {
          resolve(await this.invoiceData(sfId, 'WRITE_OFF'));
        } else if (type === 'latefees') {
          resolve(await this.invoiceData(sfId, 'LATE_FEE'));
        }
      }
    });

    return promise;
  }

  private invoiceData = (sfId: string, type: string) => {
    const passData: any = { Type: type, Ids: [sfId], UserId: '', IsPreview: true };
    const promise = new Promise((resolve, reject) => {
      this.http.post(`/api/invoices`, passData).subscribe(data => {
        resolve(data);
      }, (err) => {
        this.authService.logout();
        reject(err);
      });
    });
    return promise;
  }
}
